(function($){
	$('[data-rotate-card]').on('click', function() {
		$('.card-image__inner').addClass('is-animating').toggleClass('is-rotated');
		$('.card-content').toggleClass('reversed');

		setTimeout(() => {
			$('.card-image__inner').removeClass('is-animating');
		}, 150);
	});

	$('.button[data-category-index]').on('click', function() {
		const index = $(this).data('category-index');

		$('.button[data-category-index]').removeClass('is-active');
		$(this).addClass('is-active');

		$('.card-meaning').removeClass('is-active');
		$(`.card-meaning[data-category-index="${index}"]`).addClass('is-active');
	});
})(jQuery);



